import React, { useState, useEffect } from "react";

import { Spinner, Button as BootstrapButton } from "react-bootstrap";
import CustomTextField from "components/CustomTextField";
import { usePostAgreggationDetailsMutation } from "../EMandiApiSlice";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { useUploadMediaFarmerMutation ,useGetCrmBankingDocumentsByIdQuery,useGetImagePathByIdQuery
} from "features/onboarding/users/farmer/farmerApiSlice";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
export const EditMandiDetails= ({ isHCL,setEditModal,handleApi,setEditDetails,editDetails

}) => { 
  const { data: documents } = useGetCrmBankingDocumentsByIdQuery(editDetails?.seller?.id, {
    skip: !editDetails?.seller?.id, 
  });
  const [editTask] = usePostAgreggationDetailsMutation();
  const [disableButton, disableSubmitBtn] = useState(false);
  const[uploadMedia]=useUploadMediaFarmerMutation()
  const[documentsAvailable,setDocuments]=useState([])
const [sendImagePath, setImagePath] = useState("");
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
   const { data: pathImage } = useGetImagePathByIdQuery(sendImagePath, {
      skip: !sendImagePath,
    });

  useEffect(()=>{
    const ProcDoc=
    documents?.data
      ?.find(
        (category) => category.document_category === "Procurement"
      )
      ?.document_types?.find(
        (type) => type.document_type === "Media"
      )
      ?.documents?.filter(
        (doc) =>
          doc.entity_id.toLowerCase() ===
          (editDetails?.id ).toLowerCase()
      ) || [];
      setDocuments(ProcDoc)
  },[documents])

  const onInputChange = (e) => {
    setEditDetails({
      ...editDetails,
      [e.target.name]: e.target.value,
    });
  };

const [selectedFile, setSelectedFile] = useState(null);
const handleSubmitDetails = (e) => {
  e.preventDefault();
  disableSubmitBtn(true);
  let payload = {
    current_status: editDetails.current_status,
    quoted_price: editDetails.quoted_price,
    quantity: editDetails.quantity,
    harvest_date: editDetails.harvest_date,
    unit_of_quantity: editDetails.unit_of_quantity,
  };

  if (selectedFile) {
    const formData = new FormData();
    formData.append("filename", selectedFile.name);
    formData.append("file_type", selectedFile.type.includes("image") ? "image" : "video");
    formData.append("media_category", "PROCUREMENT")
    formData.append("media_type", "MEDIA")
    formData.append("files", selectedFile);
    formData.append("entity_id", editDetails.id);
    uploadMedia({id:editDetails.seller.id, formData})
      .unwrap()
      .then((mediaResponse) => {
        if (mediaResponse.success) {
          payload={
            ...payload,
            media :{
            media_category: "procurement",
            media_type: "media",
            entity_id: editDetails.id
            }
          }
          editTask({ tradeId: editDetails.id, payload })
            .unwrap()
            .then(() => {
              swal("Trade Updated Successfully", {
                buttons: false,
                icon: "success",
                title: "Updated Details",
                timer: 1500,
              });
              setEditModal(false);
              disableSubmitBtn(false);
              handleApi();
            })
            .catch(() => {
              toast.error("Error while Updating Details");
              disableSubmitBtn(false);
            });
        } else {
          toast.error("Media upload failed");
          disableSubmitBtn(false);
        }
      })
      .catch(() => {
        toast.error("Error while uploading media");
        disableSubmitBtn(false);
      });
  } else {
    editTask({ tradeId: editDetails.id, payload })
      .unwrap()
      .then(() => {
        swal("Trade Updated Successfully", {
          buttons: false,
          icon: "success",
          title: "Updated Details",
          timer: 1500,
        });
        setEditModal(false);
        disableSubmitBtn(false);
        handleApi();
      })
      .catch(() => {
        toast.error("Error while Updating Details");
        disableSubmitBtn(false);
      });
  }
};
  const showLargeImage = (imagePath) => {
    setImagePath(imagePath);
    setOpenLightBox(true);
  };
    useEffect(() => {
      if (pathImage) setImageInLightbox(pathImage.data.url);
    }, [pathImage]);

  return (
    <div>
       <form onSubmit={handleSubmitDetails}>
  <p className="mt-2 mb-2">
    Update Details of <span className="checkingcss">{editDetails?.seller?.name}</span> of commodity{" "}
    <span className="checkingcss">{editDetails?.commodity?.name}</span>.
  </p>
  <div className="row text-gray mt-3">
    <div className="col-md-3 mb-3 align-items-center">
      <CustomTextField
        type="text"
        name="quantity"
        value={editDetails?.quantity}
        onChange={onInputChange}
      />
    </div>
    <div className="col-md-2">
      <CustomTextField
        type="text"
        name="Unit"
        value={editDetails?.unit_of_quantity}
        disabled
      />
    </div>
    <div className="col-md-3 mb-3">
      <CustomTextField
        type="text"
        name="quoted_price"
        value={editDetails?.quoted_price}
        onChange={onInputChange}
      />
    </div>
    <div className="col-md-4 mb-3">
      <CustomTextField
        type="select"
        name="current_status"
        value={editDetails?.current_status}
        onChange={onInputChange}
        className="text-gray"
      >
        <option value="">Select</option>
        <option value="Procurement Done">Procurement Done</option>
        <option value="Negotiation Done">Negotiation Done</option>
      </CustomTextField>
    </div>
    <div className="col-md-4 mb-3">
      <label>Upload Media (Optional)</label>
      <input type="file" accept="image/*,video/*" onChange={(e) => setSelectedFile(e.target.files[0])} />
    </div>
    {documentsAvailable.length > 0 && (
          <div className="mt-2">
            <div className="d-flex flex-wrap">
              {documentsAvailable
              .map((doc) => (
                <div
                  key={doc.id}
                  className="d-flex align-items-center p-2"
                  style={{
                    borderBottom: "1px solid #ddd",
                    paddingBottom: "6px",
                    gap: "10px",
                    cursor: "pointer",
                    transition: "background 0.2s ease-in-out",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.background = "#f8f9fa")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                  onClick={() => showLargeImage(doc.path)}
                >
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                    width="50"
                    height="35"
                    style={{
                      borderRadius: "4px",
                      objectFit: "cover",
                      flexShrink: 0,
                    }}
                    alt="KYC Document"
                  />
                 
                </div>
              ))}
                {openLightbox && (
                            <Lightbox
                              image={lightBoxViewImage}
                              title="Image Title"
                              onClose={() => setOpenLightBox(false)}
                            />
                          )}
            </div>

          </div>
        )}

    <div className="col-12 d-flex justify-content-center mt-3">
      <BootstrapButton className="submit-btn px-4 py-2" size="sm" type="submit">
        Submit {disableButton && <Spinner size="sm" className="ms-2" />}
      </BootstrapButton>
    </div>
  </div>
</form>

    </div>
  );
};
